import { combineReducers } from "redux";

export const types = {
  SELECT_SUBJECT: "SUBJECT_QUERY/SELECT_SUBJECT",
};

const initialState = {
  subject: [],
};

export const actions = {
  //选科查询将选择的选科保存到redux
  cacheSubject: (subject) => {
    return {
      type: types.SELECT_SUBJECT,
      subject,
    };
  },
};

//选中选科的reducer
const subjectData = (state = initialState, action) => {
  switch (action.type) {
    case types.SELECT_SUBJECT:
      return { ...state, subject: action.subject };
    default:
      return { ...state };
  }
};

const reducer = combineReducers({
  subjectData,
});

export default reducer;



// WEBPACK FOOTER //
// ./src/redux/modules/subjectquery.js